import { desktopHomePageAccessibilityTagsAtom } from "./atoms";
import { useAtom } from "jotai";

export function useAccessibilityTagsHomePage() {
  const [accessibilityTags] = useAtom(desktopHomePageAccessibilityTagsAtom);

  const tagsToAdd: any[] = [];
  const prepareData = () => {
    const ids = [964, 844, 553, 554, 753];
    const idstoAdd: any[] = [];
    accessibilityTags.forEach((option: any) => {
      option.accessibility_tags.forEach((o: any) => {
        if (ids.includes(o.id)) {
          tagsToAdd.push(o);
          idstoAdd.push(o.id);
        }
      });
    });
    return accessibilityTags.map((option: any) => {
      const filteredTags = option.accessibility_tags.filter(
        (o: any) => !idstoAdd.includes(o.id)
      );
      return { ...option, accessibility_tags: filteredTags };
    });
  };

  const preparedData = prepareData();

  return { accessibilityTags, tagsToAdd, preparedData };
}
